import React from 'react'
import { StyledRotatedSyncRounded } from '../GraphicSidebar/styled'
import { PublishedIcon } from '../PublishedIcon/'

interface IPublishIndicator {
  status: 'published' | 'publishing' | 'failure' | ''
}

export const PublishIndicator = ({ status }: IPublishIndicator) => {
  switch (status) {
    case 'publishing':
      return (
        <StyledRotatedSyncRounded
          color="primary"
          className="auto-publishing-icon"
        />
      )
    case 'published':
      return <PublishedIcon color="primary" className="auto-published-icon" />
    case 'failure':
      return (
        <PublishedIcon failure="true" className="auto-published-failure-icon" />
      )
    default:
      return null
  }
}
